__turbopack_context__.v({
  "title": "SuggestedFacets-module__PlldRW__title",
});
